// Import Swiper
import Swiper from 'swiper/bundle';

// Initialize Image Cards Carousel Overlay
$('.pattern-image-cards-carousel-overlay').each(function() {
  let self = $(this);
  let swiperContainer = self.find('.swiper');
  
  if (swiperContainer.length === 0) return;
  
  // Get the carousel ID from the second class
  let carouselId = swiperContainer.attr('class').split(' ')[1];
  
  new Swiper('.' + carouselId, {
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next-' + carouselId,
      prevEl: '.swiper-button-prev-' + carouselId,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
});
